/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const Spot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="Spot">
    <path
      d="M1 10C1 5.02944 5.02944 1 10 1H16C20.9706 1 25 5.02944 25 10V16C25 20.9706 20.9706 25 16 25H10C5.02944 25 1 20.9706 1 16V10Z"
      stroke="var(--moreMenuIconFill)"
      strokeWidth="1.4"
    />
    <line x1="9" y1="20" x2="17" y2="20" stroke="#2894F9" strokeWidth="2" />
    <path
      d="M17.95 12L13 7.05005L8.04999 12L13 16.95L17.95 12Z"
      stroke="var(--moreMenuIconFill)"
      strokeWidth="0.8"
    />
  </svg>
);

export default Spot;
